module.exports = __webpack_public_path__ + "static/media/apng_weak_yellow.7dae3cbf.png";